import SuperText from "../SuperText";
import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultTable from "../../../components/table/ResultTable";
import EmptyLine from "../EmptyLine";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";
import Footnote from "../../../components/Footnote";

export function B5({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const RenderData = ({data, settings, report, globalVariables}) => {
    return (
        <>
            <ResultText style={{marginBottom: 8}}>
                Contraction and expansion ratios at the US/DS of the structures are calculated as follows. Ratios that are not within {settings?.thresholds?.transition_ratio_tol * 100}% of the User Preference values ({settings?.defaults?.contraction_ratio}:1 and {settings?.thresholds?.expansion_ratio_min}:1 – {settings?.thresholds?.expansion_ratio_max}:1) are highlighted in red color.
                <EmptyLine/>
            </ResultText>
            <EmptyLine/>
            {
                data.map(r => {
                    const item = {
                        crossSection: r.cross_section,
                        type: r.type,
                        upDist: r.up_dist,
                        usName: r.up_cross_section,
                        dsName: r.down_cross_section,
                        upLeftRatio: r.up_left_ratio,
                        upLeftRatioSkew: r.up_left_ratio_skewed,
                        upLeftRatioInRange: r.up_left_ratio_in_range,
                        upLeftDist: r.up_left_diff,
                        upLeftCalc: r.up_left_calc,
                        upRightRatio: r.up_right_ratio,
                        upRightRatioSkew: r.up_right_ratio_skewed,
                        upRightRatioInRange: r.up_right_ratio_in_range,
                        upRightDist: r.up_right_diff,
                        upRightCalc: r.up_right_calc,
                        downDist: r.down_dist,
                        downLeftDist: r.down_left_diff,
                        downLeftRatio: r.down_left_ratio,
                        downLeftRatioSkew: r.down_left_ratio_skewed,
                        downLeftRatioInRange: r.down_left_ratio_in_range,
                        downLeftCalc: r.down_left_calc,
                        downRightDist: r.down_right_diff,
                        downRightRatio: r.down_right_ratio,
                        downRightRatioSkew: r.down_right_ratio_skewed,
                        downRightRatioInRange: r.down_right_ratio_in_range,
                        downRightCalc: r.down_right_calc,
                        skew: r?.skew_map ?? r.skew
                    }

                    if(typeof item.skew === 'number') {
                        item.skew = item.skew.toFixed(settings?.decimalPlaces?.skew_angle)
                    }

                    return (
                        <>
                            <ResultTable
                                footer={(
                                    <>
                                        Skew Angle: {item.skew}
                                    </>
                                )}
                            >
                                <ResultHeader>
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'left'}}/>
                                        <ResultHeaderCell colSpan={3}>Distance (ft)</ResultHeaderCell>
                                        <ResultHeaderCell colSpan={2}>Ratio</ResultHeaderCell>
                                    </ResultRow>
                                    <ResultRow>
                                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'left'}}>
                                            <CheckCSName
                                                csName={(
                                                    <>
                                                        {item.type || 'Type'} at RS {r.cross_section}
                                                    </>
                                                )}
                                                csNameVal={item.crossSection || 'cross_section'}
                                            />
                                        </ResultHeaderCell>
                                        <ResultHeaderCell style={{
                                            textAlign: 'right',
                                            width: HecRasHelper.getWidth(8)
                                        }}>XS</ResultHeaderCell>
                                        <ResultHeaderCell style={{
                                            textAlign: 'right',
                                            width: HecRasHelper.getWidth(8)
                                        }}>Left</ResultHeaderCell>
                                        <ResultHeaderCell style={{
                                            textAlign: 'right',
                                            width: HecRasHelper.getWidth(8)
                                        }}>Right</ResultHeaderCell>
                                        <ResultHeaderCell style={{
                                            textAlign: 'right',
                                            width: HecRasHelper.getWidth(8)
                                        }}>Left</ResultHeaderCell>
                                        <ResultHeaderCell style={{
                                            textAlign: 'right',
                                            width: HecRasHelper.getWidth(8)
                                        }}>Right</ResultHeaderCell>
                                    </ResultRow>
                                </ResultHeader>
                                <ResultRow>
                                    <ResultHeaderCell style={{textAlign: 'left', fontWeight: 'normal'}}>US ({item.usName})</ResultHeaderCell>
                                    <ResultBodyCell
                                        style={{textAlign: 'right'}}>{item.upDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell
                                        style={{textAlign: 'right'}}>{item.upLeftDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell
                                        style={{textAlign: 'right'}}>{item.upRightDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.upLeftCalc}/>
                                        {isLimit(item.upLeftRatio, item.upLeftRatioInRange)}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.upRightCalc}/>
                                        {isLimit(item.upRightRatio, item.upRightRatioInRange)}
                                    </ResultBodyCell>
                                </ResultRow>
                                <ResultRow>
                                    <ResultHeaderCell style={{textAlign: 'left', fontWeight: 'normal'}}>DS ({item.dsName})</ResultHeaderCell>
                                    <ResultBodyCell
                                        style={{textAlign: 'right'}}>{item.downDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell
                                        style={{textAlign: 'right'}}>{item.downLeftDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell
                                        style={{textAlign: 'right'}}>{item.downRightDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.downLeftCalc}/>
                                        {isLimit(item.downLeftRatio, item.downLeftRatioInRange)}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.downRightCalc}/>
                                        {isLimit(item.downRightRatio, item.downRightRatioInRange)}
                                    </ResultBodyCell>
                                </ResultRow>
                            </ResultTable>
                            <EmptyLine/>
                        </>
                    )
                })
            }

            <EmptyLine height={16}/>
            <Footnote>
                <div><SuperText text={'1'}/> Abutment data is used to identify the bridge opening station.</div>
                <div><SuperText text={'2'}/> Low chord or Abutment data does not define bridge opening station.</div>
                <div><SuperText text={'3'}/> Ineffective area station is missing.</div>
                <div><SuperText text={'4'}/> Contraction/Expansion ratio could not be calculated since the ineffective
                    station is at the structure opening.
                </div>
            </Footnote>
        </>
    )
}

const isLimit = (val, inRange) => {
    if (inRange) return val

    return (
        <span style={{color: 'red'}}>
            {val || 'None'}
        </span>
    )
}

const Description = ({text, row, settings, globalVariables, report}) => {
    if(row.error_id === MessageCodes.Internal.ST01.error_id) {
        const data = row.data;
        if(data) {
            return (
                <>
                    <RenderData
                        data={data}
                        settings={settings}
                        report={report}
                        globalVariables={globalVariables}
                    />
                </>
            )
        }
    }
}